import styled from 'styled-components'

import { Layout } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-wc/dist/tokens'

export const StyledContainer = styled(Layout.Box)`
  width: 100%;
  max-width: 1192px;
  margin: 0 auto;
`

export const StyledReportCard = styled(Layout.Box)`
  width: 100%;
  max-width: 712px;
  margin: 0 auto;
`

export const StyledReportImage = styled.img<{ $disabled?: boolean }>`
  width: 290px;
  height: 290px;
  border-radius: 12px;
  border: 1px solid rgb(${getToken('color-border')});
  opacity: ${props => (props.$disabled ? 0.4 : 1)};
  filter: ${props => (props.$disabled ? 'grayscale(100%)' : 'none')};
  transition: opacity 0.2s ease, filter 0.2s ease;
`
